module.exports = __webpack_public_path__ + "static/img/29.66ea33e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/29.png
// module id = LT1A
// module chunks = 1